// Z-Index Constants
// Use these constants instead of hardcoded z-index values in React components
// Organized by layers from lowest to highest

// BEHIND CONTENT LAYER (negative values)
export const Z_INDEX_BEHIND_CONTENT = -1

// BASE LAYOUT LAYER (1-10)
export const Z_INDEX_BASE_SCENE = 1
export const Z_INDEX_METABASE = 4
export const Z_INDEX_SUBSCRIPTION_PAYMENT_SUMMARY = 10
export const Z_INDEX_APPOINTMENT_PIN_ACTIVE = 10
export const Z_INDEX_APPOINTMENT_PIN_DETAILS = 10

// UI ELEMENTS LAYER (100-999)
export const Z_INDEX_TECHNICIAN_TOP_NAVBAR = 500

// OVERLAYS AND MODALS LAYER (1000-9999)
export const Z_INDEX_CAROUSEL_GRADIENTS = 1000
export const Z_INDEX_CAROUSEL_CONTENT = 1001
export const Z_INDEX_ONSITE_PAGE = 1001
export const Z_INDEX_ESTIMATE_REVIEW_CONTROLS = 1002
export const Z_INDEX_CURRENT_VISIT_CARD = 1002
export const Z_INDEX_TECHNICIAN_BOTTOM_NAV = 1002
export const Z_INDEX_APPOINTMENT_DETAIL_STICKY = 1002
export const Z_INDEX_TECHNICIAN_BOTTOM_NAV_POINTER_EVENTS = 1003
export const Z_INDEX_FULL_SCREEN_MODAL = 1004
export const Z_INDEX_TECHNICIAN_HOMEPAGE_HEADER = 1004
export const Z_INDEX_TECHNICIAN_BOTTOM_NAV_TOP = 1004
export const Z_INDEX_ACCEPT_ESTIMATE_VIEW = 1004
export const Z_INDEX_ONSITE_PAGE_NO_NAV = 1005
export const Z_INDEX_EVENT_BOX = 1009
export const Z_INDEX_PRICEBOOK_LAYER = 1010
export const Z_INDEX_ONSITE_MODAL = 1010
export const Z_INDEX_PRICEBOOK_PHOTO_THUMBNAIL = 1011
export const Z_INDEX_QR_CODE_MODAL = 1011
export const Z_INDEX_VARIOUS_MODALS = 1020
export const Z_INDEX_CLOCK_IN_MODAL = 1031
export const Z_INDEX_PHOTO_CROP_MODAL = 1240
export const Z_INDEX_SECONDARY_MODAL = 1500
export const Z_INDEX_MOBILE_SELECT = 2000

// HIGH PRIORITY OVERLAYS (5000-9999)
export const Z_INDEX_GALLERY_MODAL = 5000
export const Z_INDEX_ASSIGNMENT_CARD_TAGS_POPOVER = 99999

// CRITICAL OVERLAYS (10000+)
export const Z_INDEX_DOWNLOADABLE_INVOICE = 10000
export const Z_INDEX_ASSIGNMENT_STATUS_STEPS = 10002
export const Z_INDEX_FULL_SCREEN_MODAL_CLOSE = 100000
export const Z_INDEX_CHECKLISTS_MODAL = 100001

// PHONE SYSTEM LAYER (111111+)
export const Z_INDEX_SUPER_TOP_PHONES_CALL_OVERLAY = 111111
export const Z_INDEX_SUPER_TOP_PHONE_SETTINGS_OVERLAY = 111112
export const Z_INDEX_SUPER_TOP_PHONE_AUDIO_SETTINGS = 111113

// ANALYTICS SYSTEM (1000000+)
export const Z_INDEX_ANALYTICS_WRAPPER = 1000000
